import { connect } from "react-redux";
import { removeVietnameseTones } from "../../../../services/helpers/Helper";
import Page from "./page";

const ListPage = (props) => {
   const { pageFacebook, search } = props;

   const getData = () => {
      let data = [];
      if (pageFacebook && pageFacebook.length > 0) {
         data = pageFacebook.filter((f) => {
            if (!!search) {
               return removeVietnameseTones(f.name.toLowerCase()).includes(removeVietnameseTones(search.toLowerCase()));
            }
            return true;
         });

      }
      return data;
   }

   return (
      <div className="app-sh-connect-page--box">
         <div className="app-sh-connect-page--list app-scrollbar app-scrollbar-visible">
            <div className="app-sh-connect-page--list-scroll">
               {getData().map((item, index) => {
                  return <Page key={index} data={item} />
               })}
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { pageFacebook } = state;

   return {
      pageFacebook
   };
};

export default connect(mapStateToProps, {
})(ListPage);